import { toast } from "react-toastify";

const UPDATE_FIELD = "errors/UPDATE_FIELD";

const initialState = {};

function errorsReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getErrors(state) {
  return state.errors;
}

export function getErrorsArr(state) {
  return Object.keys(getErrors(state)).map((key) => getErrors(state)[key]);
}

export function updateError(error) {
  return (dispatch, getState) => {
    let errorMessage = error && error.message ? error.message : error[0] && error[0].message ? error[0].message : error;

    /*
    DISABLE ERROS FOR DEMOS
    toast(errorMessage, {
      type: toast.TYPE.ERROR,
      position: toast.POSITION.TOP_CENTER,
      autoClose: 7500
    });
    */

    return dispatch({
      type: UPDATE_FIELD,
      data: { errorMessage, created: new Date().getTime() },
      key: Object.keys(getErrors(getState())).length
    });
  };
}

export default errorsReducer;
